<template>
    <div class="updates-list main-container">
        <h1 class="title">Updates</h1>
        <p v-if="!loggedIn" id="updates-login-prompt">
            <a href="#" @click.prevent="clickedLogin">Log in</a> to see more pages.
        </p>

        <ul v-if="history && history.length">
            <li v-for="page in history" :key="page.entryID">
                <router-link :to="linkForPage(page.entries[0].page)">{{ page.pageTitle }}</router-link>
                <ul>
                    <li v-for="entry in page.entries" :key="entry._id">
                        <span class="hide-on-mobile">{{ entry.action }} by </span>
                        <span class="full-name">{{ entry.author.fullName }}</span>
                        <span class="hide-on-mobile"> on</span>
                        {{ formattedDate(entry.date) }}
                    </li>
                </ul>
            </li>
        </ul>
        <p v-else class="loading">Loading history…</p>

        <login-popover ref="loginPopover"
            reason="You must be a member of the Paradise Motel Discord server to log in to the wiki." />
    </div>
</template>


<script>

    import HistoryService from '@/services/HistoryService'
    import LinkForPage from '@/mixins/link-for-page'
    import LoginPopover from '@/components/LoginPopover.vue'
    const dateformat = require('dateformat')

    export default {
        name: 'updates',
        mixins: [LinkForPage],
        components: { LoginPopover },
        data() {
            return {
                history: []
            }
        },
        computed: {
            loggedIn() {
                return this.$store.getters.isLoggedIn
            }
        },
        watch: {
            loggedIn() {
                this.getHistory()
            }
        },
        mounted() {
            document.title = 'Updates'
            this.getHistory()
        },
        methods: {
            async getHistory() {
                const historyResponse = await HistoryService.getUpdates()
                this.history = []
                let previousEntry = null;

                // collate duplicates by page ID
                historyResponse.data.forEach((entry) => {
                    if ((!previousEntry) || (previousEntry.page.shortid !== entry.page.shortid)) {
                        this.history.push({
                            entryID: entry._id,
                            pageShortID: entry.page.shortid,
                            pageTitle: entry.page.title,
                            entries: [entry]
                        })
                    } else {
                        this.history[this.history.length - 1].entries.push(entry)
                    }

                    previousEntry = entry
                })

                // this.history = historyResponse.data
            },
            formattedDate(dt) {
                return dateformat(dt, 'ddd mmmm dS, yyyy, h:MM tt')
            },
            clickedLogin() {
                this.$refs.loginPopover.showFromElement('updates-login-prompt')
            }
        }
    }

</script>


<style lang="scss">

    .updates-list {
        padding-bottom: 100px;

        @include mobile {
            .hide-on-mobile {
                display: none !important;
            }

            .full-name::after {
                content: ';';
            }
        }

        #updates-login-prompt {
            font-style: italic;
            font-size: 14px;
            line-height: 14px;
            margin-top: -4px;
            margin-bottom: 4px;
            text-align: center;
        }

        .loading {
            margin-top: 5vh;
            text-align: center;
        }

        ul {
            list-style-type: none;
            margin: 0;
            padding: 0;
        }

        & > ul {
            text-align: center;
            margin-top: 30px;

            & > li {
                font-size: 18px;
                margin-bottom: 20px;

                & > a {
                    display: inline-block;
                    padding-bottom: 4px;
                }
            }

            ul li {
                font-size: 12px;
            }
        }
    }

</style>
